import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { ApplicationEligibility } from '@features/application-eligibility/application-eligibility.typing';

@Injectable({ providedIn: 'root' })
export class ApplicationEligibilityResources {

  constructor (
    private httpRestService: HttpRestService
  ) { }

  organizationEligibilityCheck (
    payload: ApplicationEligibility.OrganizationEligibilityCheckPayload
  ): Promise<ApplicationEligibility.OrganizationEligibilityCheckResponse> {
    return this.httpRestService.post(
      'api/manager/applications/OrganizationEligibilityCheck',
      payload
    );
  }

  checkOrganizationEligibilityStatus (
    payload: ApplicationEligibility.ApplicantCopyEligibilityPayload
  ): Promise<ApplicationEligibility.OrganizationEligibilityCheckResponse> {
    const endpoint = '/api/portal/applications/OrganizationEligibilityCheck';

    return this.httpRestService.post(endpoint, payload);
  }

  doesOrgPassProgramEligibility (
    organizationId: number,
    cycleId: number,
    programId: number
  ): Promise<{ mayApply: boolean }> {
    const endpoint = `api/portal/applications/MayApply?grantProgramId=${programId}&grantProgramCycleId=${cycleId}${!!organizationId ? `&organizationId=${organizationId}` : ''}`;

    return this.httpRestService.get(endpoint);
  }
}
